import { useState } from "react";
import { ShieldAlert } from "lucide-react";
import RoomList from "@/components/community/RoomList";
import RoomView from "@/components/community/RoomView";
import CommunityLocked from "@/components/community/CommunityLocked";
import ModerationPanel from "@/components/community/ModerationPanel";

export default function ForumTab({ api, me }) {
  const [room, setRoom] = useState("general");
  const [modOpen, setModOpen] = useState(false);
  if (!me.access) return <CommunityLocked me={me} />;
  const current = me.rooms.find((r) => r.id === room);
  return (
    <div data-testid="community-forum-tab">
      <div className="mb-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p className="text-muted-foreground max-w-xl text-sm sm:text-base">Swap tips, share resources and learn from other carriers going through the same steps.</p>
        {me.is_mod && (
          <button onClick={() => setModOpen((v) => !v)} data-testid="community-moderation-toggle" aria-pressed={modOpen}
            className={`min-h-[44px] px-4 font-mono-label text-[11px] border inline-flex items-center gap-2 shrink-0 transition-colors ${modOpen ? "border-[#FFD600] text-[#FFD600]" : "border-[#262626] hover:border-white"}`}>
            <ShieldAlert size={14} /> {modOpen ? "Back to rooms" : "Moderation"}
          </button>
        )}
      </div>
      {me.muted && (
        <div className="brutal-border border-[#F87171] text-sm text-[#F87171] p-3 mb-4" data-testid="community-muted-banner">
          You've been muted by the CarrierLaunch team. You can still read, but you can't post right now.
        </div>
      )}
      {modOpen ? (
        <ModerationPanel api={api} />
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-[260px_minmax(0,1fr)] gap-4 lg:gap-6">
          <div className="min-w-0"><RoomList rooms={me.rooms} room={room} onPick={setRoom} /></div>
          <RoomView key={room} api={api} room={current} me={me} />
        </div>
      )}
    </div>
  );
}
